import { Icon } from '@abyss/web/ui/Icon';

export const HealthAccessIcon = () => (
  <Icon
    css={{
      width: '48px',
      height: '48px',
    }}
    size="$md"
  >
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_242_1954)">
        <path
          d="M13.9999 37.9903H15.9999V10.0203H31.9999V37.9903H33.9999V8.02026H13.9999V37.9903Z"
          fill="#00BED5"
        />
        <path
          d="M19.0001 15.7498V43.5198L32.0001 37.9998V9.99976L19.0001 15.7498Z"
          fill="#FF612B"
        />
      </g>
      <defs>
        <clipPath id="clip0_242_1954">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);
